import { render } from "./GerenciamentoCidades.vue?vue&type=template&id=d27f1bfe&scoped=true"
import script from "./GerenciamentoCidades.vue?vue&type=script&lang=js"
export * from "./GerenciamentoCidades.vue?vue&type=script&lang=js"

import "./GerenciamentoCidades.vue?vue&type=style&index=0&id=d27f1bfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27f1bfe"]])

export default __exports__